import React, { useEffect, useRef } from 'react';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import { Card } from 'antd';
import L from 'leaflet';
import { Device } from '../../types/Device';
import { MAP_TILE_URL } from '../../const/const';
import { LEAFLET_ICONS } from 'utils/app/assets/images/leaflet';
import { isPointInKazakhstan } from '../../utils/kazakhstanBounds';

interface LocationMapProps {
    device: Device | null;
}

delete L.Icon.Default.imagePath;

const icon = L.icon({
    iconUrl: LEAFLET_ICONS.markerIcon,
    iconRetinaUrl: LEAFLET_ICONS.markerIconRetina,
    shadowUrl: LEAFLET_ICONS.markerShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
});
const LocationMap: React.FC<LocationMapProps> = ({ device }) => {
    const mapRef = useRef<L.Map | null>(null);

    // Обновление центра карты при изменении пропса device
    useEffect(() => {
        if (mapRef.current && device && isPointInKazakhstan(device.latitude, device.longitude)) {
            mapRef.current.setView([device.latitude, device.longitude], 15);
        }
    }, [device]);

    const validDevice = device &&
        device.latitude !== 0 &&
        device.longitude !== 0 &&
        isPointInKazakhstan(device.latitude, device.longitude) ? device : false;

    if (!device) {
        return <div>No device selected</div>; // Обработка случая, когда device не задан
    }

    if (!validDevice) {
        return (
            <div
                style={{
                    height: 'calc(100vh - 176px)',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: '#f0f0f0',
                    borderRadius: '8px',
                    marginTop: 16,
                }}
            >
                Нет устройств с допустимыми координатами для отображения
            </div>
        );
    }

    return (
        <div className="LocationMap">
            <MapContainer
                ref={mapRef}
                center={[device.latitude, device.longitude]}
                zoom={15}
                style={{
                    height: 'calc(100vh - 176px)',
                    width: '100%',
                    borderRadius: '8px',
                    marginTop: 16,
                }}
                scrollWheelZoom={true}
            >
                <TileLayer
                // attribution={`&copy; <a href="${MAP_TILE_URL}">Local Server Map</a>`}
                // url={`${MAP_TILE_URL}/{z}/{x}/{y}.png`}
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url={MAP_TILE_URL}
                    subdomains={['a', 'b', 'c']}
                />
                <Marker key={device.UID} position={[device.latitude, device.longitude]} icon={icon}>
                    <Popup>
                        <div>
                            <p>
                                <strong>Название устройства:</strong> {device.name}
                            </p>
                            <p>
                                <strong>Описание устройства:</strong> {device.description}
                            </p>
                            <p>
                                <strong>Модель устройства:</strong> {device.model}
                            </p>
                        </div>
                        {device.online && <p style={{ color: 'green' }}>Онлайн</p>}
                        {!device.online && <p style={{ color: 'red' }}>Оффлайн</p>}
                    </Popup>
                </Marker>
            </MapContainer>
        </div>
    );
};

export default LocationMap;
